/**
 * API Authentication Initializer
 *
 * Sets up the Clerk token getter for API clients on app initialization.
 * This component must be rendered inside ClerkProvider.
 */
import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '../services/api';
import { setClerkTokenGetter } from '../lib/api';

export default function ApiAuthInitializer() {
  const { getToken } = useAuth();

  useEffect(() => {
    // Create a token getter function that uses Clerk's getToken
    const tokenGetter = async () => {
      try {
        return await getToken();
      } catch (error) {
        console.error('Failed to get Clerk token:', error);
        return null;
      }
    };

    // Set the token getter for both API clients
    setTokenGetter(tokenGetter);
    setClerkTokenGetter(tokenGetter);

    console.log('API authentication initialized with Clerk tokens');
  }, [getToken]);

  // This component doesn't render anything
  return null;
}
